import productGroup from '../helpers/productGroup';
import reveal from '../helpers/reveal';

interface IColor {
  [keyof:string]:any
}

class ProductColors {
  async init() {
    const productColors: HTMLElement = document.querySelector('[data-product-colors]');

    if (productColors) {
      let products:any = await productGroup.getJSON();
      
      products = products.map((product: any) => {
        product.selected = product.handle === window.theme.product.handle ? 'product-colors__color--selected' : '';
        return product;
      });

      const swatches = this.getSwatchesFromString(window.theme.swatchString);
      const productHandle = window.theme.product.handle;
      productColors.insertAdjacentHTML('afterbegin', this.render(products, swatches, productHandle));
      if (products.length > 1) reveal.closestHideClassName(productColors);
    }
  }

  getSwatchesFromString(swatchString:string) {
    return swatchString.split(',').reduce((acc:IColor, swatchKeyValue:string) => {
      const swatch = swatchKeyValue.split(':').map(value => value.toLowerCase().trim());
      acc[swatch[0]] = swatch[1];
      return acc;
    }, {});
  }

  render(products:any, swatches:IColor, productHandle: string) {
    return `
      <ul class="product-colors">
        ${ products.map((product:any) => this.productColor(product, swatches)).join('') }
      </ul>
    `
  }

  productColor(product:any, swatches:IColor) {
    return `
      <li class="product-colors__color ${ product.selected }">
        <a class="product-colors__link" href="${ product.url }" style="background-color: ${ swatches[product.color] }">
          <span class="hide">${ product.color }</span>
        </a>
      </li>
    `
  }
}

export default new ProductColors();